import { lazy, Suspense } from "react";
import SEO from "@/components/SEO";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import StickyCTA from "@/components/landing/StickyCTA";

// Above-the-fold (Navbar + Hero) carga inmediata.
// El resto se divide en chunks y carga bajo demanda al hacer scroll para reducir el JS crítico.
const Differentiation = lazy(() => import("@/components/landing/Differentiation"));
const HowItWorks = lazy(() => import("@/components/landing/HowItWorks"));
const ProductShowcase = lazy(() => import("@/components/landing/ProductShowcase"));
const Pricing = lazy(() => import("@/components/landing/Pricing"));
const Enterprise = lazy(() => import("@/components/landing/Enterprise"));
const Extras = lazy(() => import("@/components/landing/Extras"));
const CaseStudies = lazy(() => import("@/components/landing/CaseStudies"));
const Testimonials = lazy(() => import("@/components/landing/Testimonials"));
const FAQ = lazy(() => import("@/components/landing/FAQ"));
const ExploreMore = lazy(() => import("@/components/landing/ExploreMore"));
const CTA = lazy(() => import("@/components/landing/CTA"));
const BookDemo = lazy(() => import("@/components/landing/BookDemo"));
const Footer = lazy(() => import("@/components/landing/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="LevelLocal | Gestión de reseñas Google y SEO local con IA"
        description="Gestiona reseñas de Google, responde con IA y convierte tu ficha de Google Maps en una fuente real de clientes. Para una o varias ubicaciones."
        canonical="/"
      />
      <Navbar />
      <Hero />
      <Suspense fallback={<div className="min-h-screen" />}>
        <Differentiation />
        <HowItWorks />
        <Pricing />
        <Enterprise />
        <Extras />
        <CaseStudies />
        <Testimonials />
        <ProductShowcase />
        <FAQ />
        <ExploreMore />
        <BookDemo />
        <CTA />
        <Footer />
      </Suspense>
      <StickyCTA />
    </div>
  );
};

export default Index;
